"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediabaseDeliveryAgentClips1Schema = void 0;
exports.MediabaseDeliveryAgentClips1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MediabaseDeliveryAgentClips1",
    "description": "Mediabase delivery agent for video preview clips",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:mediabase-delivery-agent-clip:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "croppings": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                        "landscape": {
                            "type": "string",
                            "description": "Mediabase delivery agent URL to the mp4 in landscape aspect (16:9)",
                            "examples": [
                                "https://da5.rbmbtnx.net/v4/RBTV/pd/FO-1URCAEBMN5N11/{op}/a:s/st:aIDzsG9thCv0aLyXvNHgka/short_preview_mp4_high.mp4"
                            ]
                        }
                    },
                    "required": [
                        "landscape"
                    ]
                }
            },
            "required": [
                "croppings"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9tZWRpYWJhc2UtZGVsaXZlcnktYWdlbnQtY2xpcC8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELEtBQUssRUFBRSxrR0FBa0c7SUFDekcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsOEJBQThCO0lBQ3ZDLGFBQWEsRUFBRSxrREFBa0Q7SUFDakUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMERBQTBEO2FBQzNEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixXQUFXLEVBQUU7b0JBQ1gsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLHNCQUFzQixFQUFFLEtBQUs7b0JBQzdCLFlBQVksRUFBRTt3QkFDWixXQUFXLEVBQUU7NEJBQ1gsTUFBTSxFQUFFLFFBQVE7NEJBQ2hCLGFBQWEsRUFBRSxvRUFBb0U7NEJBQ25GLFVBQVUsRUFBRTtnQ0FDVixtSEFBbUg7NkJBQ3BIO3lCQUNGO3FCQUNGO29CQUNELFVBQVUsRUFBRTt3QkFDVixXQUFXO3FCQUNaO2lCQUNGO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsV0FBVzthQUNaO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=